import { Button, Col, Form, Input, Row, Spin } from "antd";
import React, { useState } from "react";
import useRegisterForm from "../../hooks/useRegisterForm";
import { registerFormRules as rules } from "../../utils/form-rules";
import { colLayout } from "../../utils/utils";
import AlternativePhones from "../alternative-phones/alternative-phones.component";
import FormDivider from "../form-divider/form-divider.component";
import InsuredPerson from "../insured-person/insured-person.component";
import Phone from "../phone/phone.component";
import Password from "./../password/password.component";
import "./register-form.styles.css";

const RegisterForm = ({ insuredPerson, onOkRegister }) => {
    const [alternativePhones, setAlternativePhones] = useState([]);

    const { form, isLoadingForm, register } = useRegisterForm(onOkRegister);

    const onFinish = (formValues) =>
        register({
            insuredPerson,
            alternativePhones,
            formValues,
        });

    return (
        <Spin tip='Creando usuario...' spinning={isLoadingForm}>
            <Form
                form={form}
                name='register'
                layout='vertical'
                requiredMark={false}
                onFinish={onFinish}
            >
                <Row>
                    <Col {...colLayout}>
                        <InsuredPerson {...insuredPerson} />
                    </Col>
                </Row>

                <Row gutter={20}>
                    <Col {...colLayout}>
                        <Form.Item
                            label='Email'
                            name='email'
                            rules={[...rules.email]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <FormDivider title='Contraseña' />
                <Password />

                <FormDivider title='Teléfono Contácto' />
                <Phone />

                <FormDivider title='Teléfonos Contácto Alternativos' />
                <AlternativePhones
                    alternativePhones={alternativePhones}
                    setAlternativePhones={setAlternativePhones}
                />

                <Form.Item>
                    <Button
                        className='register-form-button '
                        type='primary'
                        htmlType='submit'
                        size='large'
                    >
                        REGISTRARME
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );
};

export default RegisterForm;
